import localStorageService from '../../utils/services/localStorage/localStorage';
import { DebugComponent } from '../debugConstants';
import { isDebugEnabled } from '../debugUtil';
import { Recording } from './stopwatch';

type StoredRecording = Recording & {
    date: number;
    group: string;
};

type StoredData = {
    recordings?: StoredRecording[];
    group?: string;
};

const LOCAL_STORAGE_KEY = 'milanote.stopwatch';
const MAX_RECORDINGS = 200;

class StopwatchSingleton {
    recordings: Array<StoredRecording> = [];
    group: string = '';

    constructor() {
        try {
            const stored: StoredData = JSON.parse(localStorageService.getItem(LOCAL_STORAGE_KEY) || '{}');
            this.recordings = stored.recordings || [];
            this.group = stored.group || '';
        } catch (e) {
            console.warn('Error when reading stopwatch recordings', e);
        }

        if (this.isEnabled()) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (window as any).stopwatch = this;
        }
    }

    isEnabled(): boolean {
        return isDebugEnabled(DebugComponent.STOPWATCH);
    }

    clear() {
        this.recordings = [];
    }

    persist() {
        localStorageService.setItem(
            LOCAL_STORAGE_KEY,
            JSON.stringify({
                recordings: this.recordings.slice(-MAX_RECORDINGS),
                group: this.group,
            } as StoredData),
        );
    }

    addRecording(r: Recording) {
        // the stopwatch singleton still exists when the debug feature is disabled,
        // it just doesn't accept any new recordings
        if (!this.isEnabled()) return;

        this.recordings.push({
            ...r,
            group: this.group,
            date: Date.now(),
        });
        this.persist();
    }

    assignGroup(group: string) {
        this.recordings
            .filter((r) => !r.group)
            .forEach((r) => {
                r.group = group;
            });
        this.persist();
    }

    tabulate(filter: (r: Recording) => boolean) {
        const groups = [...new Set(this.recordings.map((r) => r.group || ''))];
        const tables = groups.map((group: string) => {
            const thisGroup = this.recordings.filter((x) => x.group === group).filter(filter || (() => true));
            const rows = thisGroup.map((x) => ({
                st: x.startDuration,
                fr: x.meanDuration?.toFixed(2),
                ['σ']: x.stdDev?.toFixed(2),
                fin: x.finishDuration,
                ['#']: x.annotation,
            }));
            return { group, rows };
        });
        tables.forEach((table) => {
            // eslint-disable-next-line no-console
            console.log(`-- ${table.group} --`);
            // eslint-disable-next-line no-console
            console.table(table.rows);
        });
    }
}

const stopwatchSingleton = new StopwatchSingleton();
export default stopwatchSingleton;
